import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GridxDeviceService } from '../../../services/gridx-device.service';
import { NotificationService } from '../../../services/notification.service';
import * as dayjs from "dayjs";
import * as utc from "dayjs/plugin/utc";
import 'dayjs/locale/de'
import * as relativeTime from 'dayjs/plugin/relativeTime';

@Component({
  selector: 'eis-gateway-diagnostics-dialog',
  templateUrl: './diagnostics-dialog.component.html',
  styleUrls: ['./diagnostics-dialog.component.scss']
})
export class DiagnosticsDialogComponent implements OnInit {
  pingInputControl: FormControl = new FormControl('', [Validators.required]);
  telnetIpControl: FormControl = new FormControl('', [Validators.required]);
  telnetPortControl: FormControl = new FormControl('', [Validators.required]);
  logLines: string[] = [];
  logFilterType = "modbus,mbus,opcua";

  constructor(@Inject(MAT_DIALOG_DATA) public data: {serial: string},
              private gridxService: GridxDeviceService,
              public notificationService: NotificationService,) { }

  ngOnInit(): void {
    dayjs.extend(utc);
    dayjs.locale('de');
  }

  ping() {
    if (this.pingInputControl.value) {
      this.gridxService.pingAddress(this.data.serial, this.pingInputControl.value).subscribe(res => {
        this.prependLog(res);
      }, error => this.notificationService.failure(error.error));
    } else{
      this.notificationService.failure("Please enter an IP-address or domain name")
    }
  }

  telnet() {
    if (this.telnetIpControl.value && this.telnetPortControl.value) {
      this.gridxService.checkTcpPort(this.data.serial, this.telnetIpControl.value, this.telnetPortControl.value).subscribe(res => {
        this.prependLog(res);
      }, error =>this.notificationService.failure(error.error));
    } else{
      this.notificationService.failure("Please enter an IP-address or a domain name and a port number")
    }
  }

  getGatewayLogs() {
    this.gridxService.getGatewayLogs(this.data.serial, this.logFilterType).subscribe(res => {
      let lines = res.split("\n");
      lines = lines.filter(n => n).reverse();
      for(let i = 0; i < lines.length; i++) {
        lines[i] = this.replaceDate(lines[i]);
      }
      this.logLines = lines.concat(["","","", ""]).concat(this.logLines);
    }, error => this.notificationService.failure(error.error));
  }

  openGatewayLog() {
    window.open("https://dashboard.iot.eon.com/explore?schemaVersion=1&panes=%7B%22p6q%22%3A%7B%22datasource%22%3A%224R0FaDQVk%22%2C%22queries%22%3A%5B%7B%22refId%22%3A%22A%22%2C%22expr%22%3A%22%7Bdevice_id%3D%5C%22" + this.data.serial + "%5C%22%7D+%7C%3D+%60%60%22%2C%22queryType%22%3A%22range%22%2C%22datasource%22%3A%7B%22type%22%3A%22loki%22%2C%22uid%22%3A%224R0FaDQVk%22%7D%2C%22editorMode%22%3A%22builder%22%2C%22direction%22%3A%22backward%22%7D%5D%2C%22range%22%3A%7B%22from%22%3A%22now-1h%22%2C%22to%22%3A%22now%22%7D%2C%22compact%22%3Afalse%7D%7D&orgId=63574")


  }

  private prependLog(logs: string) {
    let lines = logs.split("\n");
    lines = lines.filter(n => n);
    this.logLines = lines.concat(["","","", ""]).concat(this.logLines);
  }

  private replaceDate(log: string) {
    const utcDate = log.substring(0, 32);
    const localDate = dayjs(utcDate).local().locale('de');

    return log.replace(utcDate, "<label class='date-label'>" + localDate.format("DD.MM.YYYY HH:mm:ss") + "</label>");
  }
}
